<template>
    <div class="byb-wrapper w-100">

        <!-- ESTADO 1: Banner -->
        <div class="byb-banner" v-if="step === 'banner'" @click="step = 'config'">
            <div class="banner-content d-flex align-items-center justify-content-between">
                <div class="banner-text">
                    <h2 class="banner-title">ARMA TU BOX</h2>
                    <p class="banner-sub">Elige tu combinación favorita de pollo</p>
                    <span class="banner-price">Desde $369</span>
                </div>
                <div class="banner-img-wrap">
                    <img :src="bannerImg" alt="Arma tu Box" class="banner-img">
                </div>
            </div>
            <button class="btn-configure">🔥 ¡Configura tu Box!</button>
        </div>

        <!-- ESTADO 2: Builder -->
        <div class="byb-builder" v-if="step !== 'banner'">

            <button class="btn-close-builder" @click="resetAll">✕</button>

            <div class="builder-split d-flex flex-wrap flex-md-nowrap">

            <!-- IZQUIERDA: Caja visual -->
            <div class="builder-left">
            <div class="box-top">
                <div class="box-visual d-flex" :class="'config-' + config">

                    <!-- Completa: 1 sección -->
                    <template v-if="config === 'complete'">
                        <div class="box-section full" :class="sectionClass(0)" @click="goToSection(0)">
                            <template v-if="sections[0].product">
                                <img :src="products[sections[0].product].image" class="section-product-img">
                                <span class="section-label">{{ products[sections[0].product].name }} {{ variantEmoji(sections[0].variant) }}</span>
                                <span class="section-qty">{{ getQty('complete', sections[0].product) }} pzas</span>
                            </template>
                            <template v-else>
                                <span class="section-empty-text">{{ currentFillIndex === 0 ? 'Elige →' : '+' }}</span>
                            </template>
                        </div>
                    </template>

                    <!-- Mitades: 2 secciones -->
                    <template v-if="config === 'halves'">
                        <div class="box-section half" :class="sectionClass(0)" @click="goToSection(0)">
                            <template v-if="sections[0].product">
                                <img :src="products[sections[0].product].image" class="section-product-img">
                                <span class="section-label">{{ products[sections[0].product].name }} {{ variantEmoji(sections[0].variant) }}</span>
                                <span class="section-qty">{{ getQty('half', sections[0].product) }} pzas</span>
                            </template>
                            <template v-else>
                                <span class="section-empty-text">{{ currentFillIndex === 0 ? 'Elige →' : '+' }}</span>
                            </template>
                        </div>
                        <div class="box-divider-v"></div>
                        <div class="box-section half" :class="sectionClass(1)" @click="goToSection(1)">
                            <template v-if="sections[1].product">
                                <img :src="products[sections[1].product].image" class="section-product-img">
                                <span class="section-label">{{ products[sections[1].product].name }} {{ variantEmoji(sections[1].variant) }}</span>
                                <span class="section-qty">{{ getQty('half', sections[1].product) }} pzas</span>
                            </template>
                            <template v-else>
                                <span class="section-empty-text">{{ currentFillIndex === 1 ? 'Elige →' : '+' }}</span>
                            </template>
                        </div>
                    </template>

                    <!-- Tercios: 3 secciones -->
                    <template v-if="config === 'thirds'">
                        <div v-for="i in 3" :key="i" class="box-section third" :class="sectionClass(i - 1)" @click="goToSection(i - 1)">
                            <template v-if="sections[i - 1].product">
                                <img :src="products[sections[i - 1].product].image" class="section-product-img">
                                <span class="section-label">{{ products[sections[i - 1].product].name }} {{ variantEmoji(sections[i - 1].variant) }}</span>
                                <span class="section-qty">{{ getQty('third', sections[i - 1].product) }} pzas</span>
                            </template>
                            <template v-else>
                                <span class="section-empty-text">{{ currentFillIndex === (i - 1) ? 'Elige →' : '+' }}</span>
                            </template>
                            <div class="box-divider-v" v-if="i < 3"></div>
                        </div>
                    </template>
                </div>

                <!-- Precio en tiempo real -->
                <div class="box-price-bar d-flex justify-content-between align-items-center">
                    <span class="price-label">Total</span>
                    <span class="price-value" :class="{ updating: priceAnimating }">${{ totalPrice }}</span>
                </div>
            </div>
            <div class="builder-left-footer">
                <button v-if="step !== 'config'" class="btn-reset-link" @click="resetAll">Empezar de nuevo</button>
            </div>
            </div><!-- /builder-left -->

            <!-- DERECHA: Opciones -->
            <div class="builder-right">
            <div class="box-bottom">

                <!-- PASO: Elegir configuración -->
                <template v-if="step === 'config'">
                    <h3 class="step-title">¿Cómo quieres tu Box?</h3>

                    <div class="config-options d-flex flex-column gap-3">
                        <div class="config-card" @click="selectConfig('complete')">
                            <div class="config-icon">
                                <div class="mini-box"><div class="mini-full"></div></div>
                            </div>
                            <div class="config-info">
                                <h4>Completa</h4>
                                <p>1 solo tipo de pollo en toda la caja</p>
                            </div>
                        </div>

                        <div class="config-card" @click="selectConfig('halves')">
                            <div class="config-icon">
                                <div class="mini-box"><div class="mini-half"></div><div class="mini-half"></div></div>
                            </div>
                            <div class="config-info">
                                <h4>Mitades</h4>
                                <p>2 tipos de pollo, mitad y mitad</p>
                            </div>
                        </div>

                        <div class="config-card" @click="selectConfig('thirds')">
                            <div class="config-icon">
                                <div class="mini-box"><div class="mini-third"></div><div class="mini-third"></div><div class="mini-third"></div></div>
                            </div>
                            <div class="config-info">
                                <h4>Tercios</h4>
                                <p>3 tipos de pollo, un tercio cada uno</p>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- PASO: Llenar sección -->
                <template v-if="step === 'fill'">
                    <h3 class="step-title">{{ fillTitle }}</h3>

                    <!-- Selector de producto -->
                    <div class="product-list d-flex flex-column gap-2">
                        <div
                            v-for="(product, key) in products"
                            :key="key"
                            class="product-option d-flex align-items-center"
                            :class="{ selected: sections[currentFillIndex].product === key }"
                            @click="selectProduct(key)"
                        >
                            <div class="product-option-img">
                                <img :src="product.image" :alt="product.name">
                            </div>
                            <div class="product-option-info flex-fill">
                                <h4>{{ product.name }}</h4>
                                <p>{{ getQty(currentSizeKey, key) }} {{ product.unitLabelPlural }} · ${{ getPrice(currentSizeKey, key) }}</p>
                            </div>
                            <div class="product-option-check" v-if="sections[currentFillIndex].product === key">✓</div>
                        </div>
                    </div>

                    <!-- Selector de variante -->
                    <div class="variant-row d-flex justify-content-center gap-3 mt-3" v-if="sections[currentFillIndex].product">
                        <button
                            class="variant-pill"
                            :class="{ active: sections[currentFillIndex].variant === 'normal' }"
                            @click="selectVariant('normal')"
                        >Normal</button>
                        <button
                            class="variant-pill spicy"
                            :class="{ active: sections[currentFillIndex].variant === 'spicy' }"
                            @click="selectVariant('spicy')"
                        >🌶️ Spicy</button>
                    </div>

                    <!-- Botón siguiente -->
                    <button
                        class="btn-next mt-3"
                        :disabled="!sections[currentFillIndex].product"
                        @click="nextSection"
                    >
                        {{ isLastSection ? 'Ver resumen' : 'Siguiente →' }}
                    </button>

                    <!-- Botón atrás -->
                    <button class="btn-back mt-2" @click="prevStep">← Atrás</button>
                </template>

                <!-- PASO: Resumen -->
                <template v-if="step === 'summary'">
                    <h3 class="step-title">Tu Box</h3>

                    <div class="summary-list">
                        <div class="summary-row d-flex justify-content-between" v-for="(section, idx) in activeSections" :key="idx">
                            <div class="summary-row-left d-flex align-items-center">
                                <img :src="products[section.product].image" class="summary-thumb">
                                <div>
                                    <span class="summary-product">{{ products[section.product].name }} {{ variantEmoji(section.variant) }}</span>
                                    <span class="summary-qty">{{ getQty(currentSizeKey, section.product) }} {{ products[section.product].unitLabelPlural }}</span>
                                </div>
                            </div>
                            <span class="summary-section-price">${{ getPrice(currentSizeKey, section.product) }}</span>
                        </div>
                    </div>

                    <div class="summary-total d-flex justify-content-between">
                        <span>Total</span>
                        <span class="summary-total-price">${{ totalPrice }}</span>
                    </div>

                    <button class="btn-cart mt-3">🛒 Agregar al Carrito</button>
                    <button class="btn-back mt-2" @click="step = 'fill'; currentFillIndex = activeSections.length - 1">← Editar</button>
                </template>

            </div>
            </div><!-- /builder-right -->

            </div><!-- /builder-split -->
        </div>
    </div>
</template>

<script>
const PRODUCTS = {
    big_mary: {
        id: 'big_mary',
        name: "Big Mary's",
        description: "Sándwich de pollo empanizado",
        image: require('@/assets/images/products/mx/big-mary-single.png'),
        unitLabel: 'sándwich',
        unitLabelPlural: 'sándwiches',
    },
    tenders: {
        id: 'tenders',
        name: 'Tenders',
        description: "Tiras de pollo empanizadas",
        image: require('@/assets/images/products/mx/pop-ins-masked.png'),
        unitLabel: 'tender',
        unitLabelPlural: 'tenders',
    },
    signature: {
        id: 'signature',
        name: 'Signature Chicken',
        description: "Pollo de hueso empanizado",
        image: require('@/assets/images/products/signature-chicken.png'),
        unitLabel: 'pieza',
        unitLabelPlural: 'piezas',
    },
};

// Cantidades por producto y tamaño de sección
const QUANTITIES = {
    complete: { big_mary: 9, tenders: 20, signature: 18 },
    half:     { big_mary: 5, tenders: 10, signature: 9 },
    third:    { big_mary: 3, tenders: 5,  signature: 6 },
};

// Precios por producto y tamaño de sección
const PRICES = {
    complete: { big_mary: 899, tenders: 369, signature: 579 },
    half:     { big_mary: 479, tenders: 199, signature: 309 },
    third:    { big_mary: 319, tenders: 139, signature: 209 },
};

// Mapa de config a tamaño de sección
const CONFIG_SIZE = {
    complete: 'complete',
    halves: 'half',
    thirds: 'third',
};

const SECTION_COUNTS = {
    complete: 1,
    halves: 2,
    thirds: 3,
};

export default {
    name: 'BuildYourBox',
    data() {
        return {
            step: 'banner', // 'banner' | 'config' | 'fill' | 'summary'
            config: null,   // 'complete' | 'halves' | 'thirds'
            sections: [
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
            ],
            currentFillIndex: 0,
            products: PRODUCTS,
            priceAnimating: false,
            bannerImg: require('@/assets/images/products/mx/combos-category.png'),
        };
    },
    computed: {
        sectionCount() {
            return this.config ? SECTION_COUNTS[this.config] : 0;
        },
        activeSections() {
            return this.sections.slice(0, this.sectionCount);
        },
        currentSizeKey() {
            return this.config ? CONFIG_SIZE[this.config] : 'third';
        },
        isLastSection() {
            return this.currentFillIndex >= this.sectionCount - 1;
        },
        totalPrice() {
            let total = 0;
            this.activeSections.forEach(s => {
                if (s.product) {
                    total += PRICES[this.currentSizeKey][s.product];
                }
            });
            return total;
        },
        fillTitle() {
            if (this.config === 'complete') return '¿Qué va en tu Box?';
            const labels = ['primera', 'segunda', 'tercera'];
            return `¿Qué va en la ${labels[this.currentFillIndex]} sección?`;
        },
    },
    methods: {
        getQty(sizeKey, productKey) {
            return QUANTITIES[sizeKey] ? QUANTITIES[sizeKey][productKey] : 0;
        },
        getPrice(sizeKey, productKey) {
            return PRICES[sizeKey] ? PRICES[sizeKey][productKey] : 0;
        },
        variantEmoji(variant) {
            return variant === 'spicy' ? '🌶️' : '';
        },
        sectionClass(idx) {
            const s = this.sections[idx];
            let cls = '';
            if (idx >= this.sectionCount) cls += ' hidden';
            else if (s.product) cls += ' filled';
            else cls += ' empty';
            if (this.step === 'fill' && this.currentFillIndex === idx) cls += ' active';
            if (s.variant === 'spicy') cls += ' spicy';
            return cls;
        },
        selectConfig(cfg) {
            this.config = cfg;
            this.sections = [
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
            ];
            this.currentFillIndex = 0;
            this.step = 'fill';
        },
        selectProduct(key) {
            const oldPrice = this.totalPrice;
            this.sections[this.currentFillIndex].product = key;
            if (this.totalPrice !== oldPrice) this.animatePrice();
        },
        selectVariant(v) {
            this.sections[this.currentFillIndex].variant = v;
        },
        nextSection() {
            if (this.isLastSection) {
                this.step = 'summary';
            } else {
                this.currentFillIndex++;
            }
        },
        prevStep() {
            if (this.currentFillIndex > 0) {
                this.currentFillIndex--;
            } else {
                this.step = 'config';
                this.config = null;
            }
        },
        goToSection(idx) {
            if (idx < this.sectionCount && this.sections[idx].product) {
                this.currentFillIndex = idx;
                this.step = 'fill';
            }
        },
        animatePrice() {
            this.priceAnimating = true;
            setTimeout(() => { this.priceAnimating = false; }, 400);
        },
        resetAll() {
            this.step = 'banner';
            this.config = null;
            this.sections = [
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
                { product: null, variant: 'normal' },
            ];
            this.currentFillIndex = 0;
        },
    },
};
</script>

<style scoped>
/* ========== WRAPPER ========== */
.byb-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px;
}

/* ========== BANNER ========== */
.byb-banner {
    background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
    border-radius: 20px;
    padding: 40px 32px 28px;
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.byb-banner:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}
.banner-title {
    font-size: 36px;
    font-weight: 900;
    color: #fff;
    letter-spacing: 2px;
    margin: 0;
    line-height: 1.1;
}
.banner-sub {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.55);
    margin: 8px 0 12px;
}
.banner-price {
    font-size: 30px;
    font-weight: 800;
    color: var(--primary);
}
.banner-img-wrap { flex-shrink: 0; }
.banner-img {
    height: 140px;
    object-fit: contain;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.4));
}
.btn-configure {
    display: block;
    width: 100%;
    margin-top: 20px;
    padding: 16px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 17px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.2s;
}
.btn-configure:hover { background: var(--vigequinary); }

/* ========== BUILDER ========== */
.byb-builder {
    background: #fff;
    border-radius: 20px;
    border: 2px solid var(--nonagenary);
    overflow: hidden;
    position: relative;
    animation: builderOpen 0.35s ease;
}
@keyframes builderOpen {
    0% { opacity: 0; transform: scale(0.96); }
    100% { opacity: 1; transform: scale(1); }
}
.btn-close-builder {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: none;
    background: rgba(0, 0, 0, 0.08);
    color: var(--text9);
    font-size: 15px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ========== SPLIT LAYOUT ========== */
.builder-split {
    min-height: 380px;
}
.builder-left {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.builder-right {
    width: 100%;
}
@media (min-width: 768px) {
    .builder-left {
        width: 42%;
        border-right: 2px solid var(--nonagenary);
        min-height: 100%;
        justify-content: space-between;
    }
    .builder-right {
        width: 58%;
    }
    .builder-split {
        align-items: stretch;
    }
}

/* ========== CAJA VISUAL ========== */
.box-top {
    background: linear-gradient(145deg, #f9f5f0, #efe6da);
    padding: 20px 16px 12px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.box-visual {
    background: linear-gradient(145deg, #d4a574, #c4956a);
    border-radius: 14px;
    padding: 6px;
    gap: 4px;
    min-height: 120px;
    flex: 1;
    box-shadow: 0 4px 16px rgba(150, 100, 50, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.15);
}
.box-section {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    padding: 10px 6px;
    min-height: 110px;
    flex: 1;
}
.box-section.hidden { display: none; }
.box-section.active {
    background: rgba(255, 255, 255, 0.45);
    box-shadow: inset 0 0 0 2px var(--primary);
    animation: sectionPulse 1.5s ease infinite;
}
@keyframes sectionPulse {
    0%, 100% { box-shadow: inset 0 0 0 2px var(--primary); }
    50% { box-shadow: inset 0 0 0 2px var(--primary), 0 0 10px rgba(232, 118, 43, 0.25); }
}
.box-section.filled {
    background: rgba(255, 255, 255, 0.65);
    animation: sectionFill 0.4s ease;
}
.box-section.filled.spicy {
    background: rgba(255, 220, 200, 0.65);
}
@keyframes sectionFill {
    0% { opacity: 0; transform: scale(0.88); }
    50% { transform: scale(1.03); }
    100% { opacity: 1; transform: scale(1); }
}
.section-product-img {
    height: 50px;
    object-fit: contain;
    filter: drop-shadow(0 2px 3px rgba(0, 0, 0, 0.12));
}
.section-label {
    font-size: 11px;
    font-weight: 700;
    color: var(--text9);
    margin-top: 3px;
    text-align: center;
    line-height: 1.2;
}
.section-qty {
    font-size: 10px;
    color: var(--text11);
    font-weight: 600;
}
.section-empty-text {
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    font-weight: 600;
}
.box-divider-v {
    width: 2px;
    background: rgba(180, 130, 80, 0.5);
    align-self: stretch;
    border-radius: 1px;
}

/* Precio */
.box-price-bar {
    margin-top: 10px;
    padding: 0 4px;
}
.price-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--text11);
}
.price-value {
    font-size: 24px;
    font-weight: 800;
    color: var(--primary);
    transition: transform 0.2s ease;
}
.price-value.updating {
    animation: priceJump 0.4s ease;
}
@keyframes priceJump {
    0% { transform: scale(1); }
    40% { transform: scale(1.15); color: #c55e1a; }
    100% { transform: scale(1); }
}

/* ========== CONTENIDO (ABAJO) ========== */
.box-bottom {
    padding: 20px 16px 24px;
}
.step-title {
    font-size: 18px;
    font-weight: 800;
    color: var(--text3);
    margin: 0 0 14px;
    text-align: center;
}

/* Selector de configuración */
.config-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px;
    border: 2px solid var(--nonagenary);
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fff;
}
.config-card:hover {
    border-color: var(--primary);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(232, 118, 43, 0.12);
}
.config-card:active { transform: translateY(0); }
.config-icon { flex-shrink: 0; }
.mini-box {
    width: 52px;
    height: 36px;
    background: linear-gradient(145deg, #d4a574, #c4956a);
    border-radius: 6px;
    display: flex;
    gap: 2px;
    padding: 3px;
    box-shadow: 0 2px 4px rgba(150, 100, 50, 0.2);
}
.mini-full {
    flex: 1;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}
.mini-half {
    flex: 1;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}
.mini-third {
    flex: 1;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
}
.config-info h4 {
    font-size: 16px;
    font-weight: 700;
    color: var(--text3);
    margin: 0;
}
.config-info p {
    font-size: 13px;
    color: var(--text11);
    margin: 2px 0 0;
}

/* Selector de producto */
.product-option {
    padding: 12px;
    border: 2px solid var(--nonagenary);
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 12px;
}
.product-option:hover { border-color: var(--primary); }
.product-option.selected {
    border-color: var(--primary);
    background: rgba(232, 118, 43, 0.05);
    box-shadow: 0 0 0 3px rgba(232, 118, 43, 0.12);
}
.product-option-img {
    width: 60px;
    height: 45px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.product-option-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
.product-option-info h4 {
    font-size: 15px;
    font-weight: 700;
    color: var(--text3);
    margin: 0;
}
.product-option-info p {
    font-size: 12px;
    color: var(--text11);
    margin: 2px 0 0;
}
.product-option-check {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--primary);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
}

/* Variante */
.variant-pill {
    padding: 8px 22px;
    border: 2px solid var(--nonagenary);
    border-radius: 25px;
    background: #fff;
    font-size: 14px;
    font-weight: 600;
    color: var(--text9);
    cursor: pointer;
    transition: all 0.2s;
}
.variant-pill.active {
    border-color: var(--primary);
    background: rgba(232, 118, 43, 0.08);
    color: var(--primary);
}
.variant-pill.spicy.active {
    border-color: #dc3c1e;
    background: rgba(220, 60, 30, 0.08);
    color: #dc3c1e;
}

/* Botones */
.btn-next {
    display: block;
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
}
.btn-next:hover { background: var(--vigequinary); }
.btn-next:active { transform: scale(0.97); }
.btn-next:disabled {
    background: var(--nonagenary);
    cursor: not-allowed;
}
.btn-back {
    display: block;
    width: 100%;
    padding: 10px;
    border: none;
    background: transparent;
    color: var(--text11);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    text-align: center;
}
.btn-back:hover { color: var(--primary); }
.btn-cart {
    display: block;
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 14px;
    background: var(--primary);
    color: #fff;
    font-size: 17px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
}
.btn-cart:hover { background: var(--vigequinary); }
.btn-cart:active { transform: scale(0.97); }
.builder-left-footer {
    padding: 12px 16px;
    text-align: center;
    width: 100%;
}
.btn-reset-link {
    display: block;
    width: 100%;
    background: none;
    border: none;
    color: var(--text15);
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
    padding: 4px;
}

/* ========== RESUMEN ========== */
.summary-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 14px;
}
.summary-row {
    padding: 10px;
    background: var(--octagenary);
    border-radius: 12px;
}
.summary-row-left {
    gap: 10px;
}
.summary-thumb {
    width: 40px;
    height: 30px;
    object-fit: contain;
}
.summary-product {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: var(--text3);
}
.summary-qty {
    display: block;
    font-size: 12px;
    color: var(--text11);
}
.summary-section-price {
    font-size: 16px;
    font-weight: 700;
    color: var(--text3);
    align-self: center;
}
.summary-total {
    padding: 12px 0;
    border-top: 2px solid var(--nonagenary);
}
.summary-total span:first-child {
    font-size: 16px;
    font-weight: 700;
    color: var(--text3);
}
.summary-total-price {
    font-size: 24px;
    font-weight: 800;
    color: var(--primary);
}

/* ========== RESPONSIVE ========== */
@media (max-width: 400px) {
    .banner-title { font-size: 22px; }
    .banner-img { height: 75px; }
    .section-product-img { height: 40px; }
    .section-label { font-size: 10px; }
}
</style>
